import { createAction, createAsyncAction } from 'services/actionConfigs';
import { PREFIX_ACTIONS } from './constants';
import { ICreateCustomerBody, ISettingReferralItem } from './types/customer';
import { IShopAllSetting } from './types/setting';
import { ICategoryItemData } from './types/categories';
import { IProductTaxConfigResData } from './types/tax';
import { IPrintCheckSettingResData } from './types/printCheck';
import { IConsentFormAgreementData } from './types/consentForm';

const get = {
  categories: createAsyncAction<undefined, ICategoryItemData[]>(PREFIX_ACTIONS + 'getCategories'),
  staffs: createAsyncAction(PREFIX_ACTIONS + 'getStaffList'),
  newStaffs: createAction(PREFIX_ACTIONS + 'getNewStaffs'),
  staffsAvailable: createAsyncAction(PREFIX_ACTIONS + 'staffsAvailable'),
  customers: createAsyncAction(PREFIX_ACTIONS + 'getCustomerList'),
  recentCustomers: createAsyncAction(PREFIX_ACTIONS + 'getRecentCustomerList'),
  shopInfo: createAsyncAction<string>(PREFIX_ACTIONS + 'getShopInfo'),
  specialDiscount: createAsyncAction(PREFIX_ACTIONS + 'getSpecialDiscount'),
  coupons: createAsyncAction(PREFIX_ACTIONS + 'getListCoupon'),
  discountSetting: createAsyncAction<boolean | undefined>(PREFIX_ACTIONS + 'getDiscountSetting'),
  otherPaymentMethod: createAsyncAction(PREFIX_ACTIONS + 'getOtherPaymentMethod'),
  allSetting: createAsyncAction<string | undefined, IShopAllSetting>(PREFIX_ACTIONS + 'getShopAllSetting'),
  productCategories: createAsyncAction(PREFIX_ACTIONS + 'getProductCategories'),
  productsVIP: createAsyncAction(PREFIX_ACTIONS + 'getProductsVIP'),
  totalStation: createAsyncAction<string>(PREFIX_ACTIONS + 'getTotalStation'),
  scheduleBooking: createAsyncAction(PREFIX_ACTIONS + 'getShopScheduleBooking'),
  couponPrint: createAsyncAction<string>(PREFIX_ACTIONS + 'getCouponPrint'),
  feeCreditCard: createAsyncAction(PREFIX_ACTIONS + 'getFeeCreditCard'),
  taxConfig: createAsyncAction(PREFIX_ACTIONS + 'getTaxConfig'),
  productTaxConfig: createAsyncAction<undefined, IProductTaxConfigResData>(PREFIX_ACTIONS + 'getProductTaxConfig'),
  simpleMenu: createAsyncAction<boolean | undefined>(PREFIX_ACTIONS + 'getSimpleMenu'),
  simpleMenuConfigCheckIn: createAsyncAction(PREFIX_ACTIONS + 'getSimpleMenuConfigCheckIn'),
  checkInOnlineLink: createAsyncAction(PREFIX_ACTIONS + 'getCheckInOnlineLink'),
  optionTips: createAsyncAction(PREFIX_ACTIONS + 'getOptionTips'),
  optionTipsAll: createAsyncAction(PREFIX_ACTIONS + 'getOptionTipsAll'),
  quickBookingService: createAsyncAction(PREFIX_ACTIONS + 'getQuickBookingService'),
  staffAvailableBooking: createAsyncAction(PREFIX_ACTIONS + 'getStaffAvailableBooking'),
  printCheckSetting: createAsyncAction<undefined, IPrintCheckSettingResData>(PREFIX_ACTIONS + 'getPrintCheckSetting'),
  settingReferral: createAsyncAction<undefined, ISettingReferralItem[]>(PREFIX_ACTIONS + 'getSettingReferral'),
  agreementConsentForm: createAsyncAction<undefined, IConsentFormAgreementData>(PREFIX_ACTIONS + 'agreementConsentForm'),
};

const initShopData = createAction(PREFIX_ACTIONS + 'initShopData');
const getNewCategories = createAsyncAction(PREFIX_ACTIONS + 'getNewCategories');
const getCategoriesWithoutBE = createAsyncAction(PREFIX_ACTIONS + 'getCategoriesWithoutBE');
const resetCouponBillPrint = createAction(PREFIX_ACTIONS + 'resetCouponBillPrint');
const doInit = {
  checkIn: createAction(PREFIX_ACTIONS + 'initCheckInShopData'),
  editTicket: createAction(PREFIX_ACTIONS + 'initEditTicketShopData'),
};

const doAdd = {
  customer: createAsyncAction<ICreateCustomerBody>(PREFIX_ACTIONS + 'doAddNewCustomer'),
};

const shopActions = {
  get,
  initShopData,
  getNewCategories,
  getCategoriesWithoutBE,
  doInit,
  doAdd,
  resetCouponBillPrint,
};

export default shopActions;
